import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { enrollmentsApi } from '@/services/api/attendance/enrollments';

export const enrollmentKeys = {
  list: (sessionId: string) => ['admin', 'attendance', 'sessions', sessionId, 'enrollments'] as const,
};

export function useEnrollmentsQuery(sessionId: string) {
  return useQuery({
    queryKey: enrollmentKeys.list(sessionId),
    queryFn: () => enrollmentsApi.list(sessionId),
    enabled: Boolean(sessionId),
  });
}

export function useEnrollMutation(sessionId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (userId: string) => enrollmentsApi.enroll(sessionId, userId),
    onSuccess: () => qc.invalidateQueries({ queryKey: enrollmentKeys.list(sessionId) }),
  });
}

export function useUnenrollMutation(sessionId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (userId: string) => enrollmentsApi.unenroll(sessionId, userId),
    onSuccess: () => qc.invalidateQueries({ queryKey: enrollmentKeys.list(sessionId) }),
  });
}
